import { render, staticRenderFns } from "./AbstractIncident.vue?vue&type=template&id=33cc40d3&scoped=true"
import script from "./AbstractIncident.vue?vue&type=script&lang=js"
export * from "./AbstractIncident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cc40d3",
  null
  
)

export default component.exports